import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getUserMailboxInfo } from 'owa-client-ids';

export async function setHeadersOnRequest(xhr: XMLHttpRequest) {
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(window.location.origin);

    if (!token) {
        token = (await tokenPromise) as string;
    }

    xhr.setRequestHeader('Authorization', `Bearer ${token as string}`);
    xhr.setRequestHeader('Content-Type', 'application/json');

    const anchorMailbox = getUserMailboxInfo().mailboxSmtpAddress;
    if (anchorMailbox) {
        xhr.setRequestHeader('X-AnchorMailbox', anchorMailbox);
    }
}
